<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="less" scoped>
    .login {
        position: relative;
        height: 100%;
        background: url("../common/image/bg.png") no-repeat 100% 100%;
        font-size: 16px;
        &-cont {
            width: 337px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -70%);
        }
        &-header {
            color: #4b89f3;
            font-size: 27px;
            margin-bottom: 18px;
            text-align: center;
            font-weight: bold;
        }
    }
</style>

<style lang="less">
    .login-cont {
        input {
            background-color: rgba(255, 255, 255, 0.5) !important;
            font-size: 16px;
            padding: 4px 7px;
            height: 34px;
        }
        button {
            font-size: 16px;
        }
    }
</style>

<template>
    <div class="login">
        <div class="login-cont">
            <div class="login-header">问渠严选管理系统</div>
            <Form ref="login-fake" :model="loginUser" :rules="ruleLogin">
                <Form-Item prop="username">
                    <Input v-model="loginUser.username" placeholder="用户名"></Input>
                </Form-Item>
                <Form-Item :error="loginError" prop="password">
                    <Input type="password" v-model="loginUser.password" placeholder="请输入密码"></Input>
                </Form-Item>
                <Form-Item prop="isRemember">
                    <Checkbox v-model="loginUser.isRemember"><span style="color: #4b89f3;">记住密码</span></Checkbox>
                </Form-Item>
                <FormItem>
                    <Button type="primary" long @click="loginIn('login-fake')">登录</Button>
                </FormItem>
            </Form>
        </div>
    </div>
</template>

<script>
  export default {
    data () {
      return {
        loginUser: {
          username: '',
          password: '',
          isRemember: false
        },
        ruleLogin: {
          username: [
            {required: true, message: '请输入用户名'}
          ],
          password: [
            {required: true, message: '请输入密码'}
          ]
        },
        loginError: ''
      }
    },
    mounted () {
      window.localStorage['token'] = ''
    },
    methods: {
      loginIn (name) {
        this.loginError = ''
        this.$refs[name].validate((valid) => {
          if (valid) {
            let params = {
              userName: this.loginUser.username,
              password: this.loginUser.password
            }
            this.$ajax.fakeExpertLogin(params).then((res) => {
              if (res.code != 0) {
                this.loginError = res.msg
              } else {
                window.localStorage['token'] = res.data
                this.getUserInfo()
              }
            })
          }
        })
      },
      getUserInfo () {
        this.$store.dispatch('getUserInfo').then((res) => {
          this.$router.push({
            path: '/'
          })
        }, (err) => {
          console.log('获取用户信息失败')
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Login-fake.vue